module.exports = __webpack_public_path__ + "img/ist otobus as.6d006b97.jpg";